__webpack_require__.p = "/kaleidoscope/";